<form *ngIf="caseFileFormGroup" [formGroup]="caseFileFormGroup">
    <div class="grid">
        
        <div class="col-12" *ngIf="!caseNoteFile.fileId">
            <p-fileUpload mode="basic" chooseIcon="pi pi-upload" (onSelect)="onFileSelect($event)"
                chooseLabel="Seleccionar fichero" />
        </div>
    </div>
    <div class=" mt-4 flex gap-2 justify-content-end">
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" icon="pi pi-check" styleClass="p-ml-2" (click)="save()"></p-button>
    </div>
</form>
<p-confirmDialog></p-confirmDialog>